import React from 'react'

class SideNavigation extends React.Component{
  constructor(props){
    super(props)
    this.hasLoaded = false
  }

  shouldComponentUpdate(nextProps, nextState){
    if(!this.hasLoaded){
      return true
    }
    return(this.selectedButton !== this.getSceneNumber(nextProps.scrollValue))
  }

  buttonPressHandler(event){
    this.props.buttonClickHandler(event)
  }

  buildButton(position, visible, selected, height){
    // const style = {
    //   width: '1.6%',
    //   paddingBottom: '1.7%',
    //   cursor: 'pointer',
    //   position: 'relative',
    //   // margin: '0.9%',
    //   visibility: (!visible)? 'visible' : "hidden",
    // }
    // const innerStyle = {
    //   borderRadius: '2px',
    //   width: '30%',
    //   height: '30%',
    //   position: 'absolute',
    //   left: '0px',
    //   right: '0px',
    //   marginLeft: 'auto',
    //   marginRight: 'auto',
    //   top: '50%',
    //   transform: 'translateY(-50%)',
    //   border: '1px solid rgba(1, 1, 1, 0.16)',
    //   float: 'left',
    //   backgroundColor: (selected) ? 'white' : 'rgba(0,0,0,0.2)',
    // }

    const style = {
      height: height + "%",
      position: 'relative',
      paddingLeft: '1%',
      cursor: 'pointer',
      width: '2%',
      visibility: (!visible)? 'visible' : "hidden",
    }
    const innerStyle = {
      width: '9px',
      height: '9px',
      backgroundColor: (selected) ? 'white' : 'rgba(0,0,0,0.2)',
      top: '50%',
      transform: 'translateY(-50%)',
      MsTransform: 'translateY(-50%)',
      position: 'relative',
      border: '1px solid rgba(1, 1, 1, 0.16)',
      borderRadius: 2,

    }
    return(<div style={style}
                key={`nav-button-${ position }`}
                onClick={this.buttonPressHandler.bind(this)}
                data-destination={position}
              >
              <div style={innerStyle}>
              </div>
            </div>)
  }

  getSceneNumber(scrollValue){
    for(let i = 0; i < this.props.sceneData.navigationPoints.length - 1; i++){
      let point = this.props.sceneData.navigationPoints[i]
      if(scrollValue > point){
        if(scrollValue < this.props.sceneData.navigationPoints[i + 1]){
          return i
        }
      }
    }
    return this.props.sceneData.navigationPoints.length - 1
  }

  buildButtons(){
    const navigationPoints = this.props.sceneData.navigationPoints
    const buttons = []
    let positionCount = 0
    let visible = false
    this.selectedButton = this.getSceneNumber(this.props.scrollValue)
    const height = 100 / navigationPoints.length
    navigationPoints.forEach((position) => {
      visible = (this.props.loadProgress && this.props.loadProgress[positionCount] !== 1)
      let button = this.buildButton(position, visible, (positionCount === this.selectedButton), height)
      if(this.props.loadProgress){
        buttons.push(button)
        positionCount++
      }
    })
    if(this.props.navigationPoints && (buttons.length >= this.props.navigationPoints.length - 1)){
      console.log("all loaded")
      this.hasLoaded = true
    }
    return buttons
  }

  render(){
    const buttons = this.buildButtons()
    const style = {
      'position': 'fixed',
      'height': '100%',
      'width': '100%',
      'top': '50%',
      'transform': 'translate(0, -50%)',
      'MsTransform': 'translate(0, -50%)',
      'overflow': 'hidden',
      'margin': '0 auto',
    }

    const buttonWrapperStyle = {
      'top': '50%',
      'transform': 'translate(0, -50%)',
      'MsTransform': 'translate(0, -50%)',
      'position': 'relative',
      'opacity': (!this.props.display) ? '0' : '1',
      'marginLeft': 'auto',
      'marginRight': 'auto',
      'overflow': 'hidden',
    }
    const buttonContainer = {
      height: '90%',
      maxHeight: '400px',
      paddingTop: '1%',
      overflow: 'hidden',
    }
      return(
        <div style={ style } className="scale-for-hd">
          <div style={buttonWrapperStyle}  id="button-holder">
            <div style={buttonContainer}>
              {buttons}
            </div>
          </div>
        </div>
      )
  }
}

export default SideNavigation



// WEBPACK FOOTER //
// ./src/SideNavigation.js